import { FC } from 'react';
import { Menu, Anchor } from '@mantine/core';
import { useTypedDispatch, useTypedSelector } from '@/store/hooks';
import { creatorActions } from '@/store/slices/creatorSlice';
import { IconTrash, IconRefresh } from '@tabler/icons-react';
import { useMutation } from '@tanstack/react-query';
import CreatorProductModuleApi from '@/api/CreatorProductModuleApi';
import { useContent } from '@/providers/ContentProvider';

const baseSlug = 'moduleContextMenu.';

export const ModuleContextMenu: FC = () => {
	const dispatch = useTypedDispatch();

	const { getContent } = useContent();

	const { options, project, preset } = useTypedSelector(
		(state) => state.creator
	);
	const source = options.isPresetMode ? preset : project;

	const { moduleId, position, deleteable } = options.moduleContextMenuData;

	const creatorModule = source.creatorProductModules.find(
		(creaProdMod) => creaProdMod.id === moduleId
	);

	const deleteCreatorProductModuleMutation = useMutation({
		mutationFn: CreatorProductModuleApi.delete,
		onSuccess: () => {
			dispatch(creatorActions.removeCreatorProductModule(creatorModule!));
		},
	});

	const handleClose = () => {
		dispatch(creatorActions.closeContextMenu());
	};

	const handleSelectModuleToSwap = () => {
		if (!creatorModule) return;
		dispatch(creatorActions.setCreatorProductModuleToSwap(creatorModule));
		handleClose();
	};

	const handleRemoveCreatorModule = () => {
		if (!creatorModule) return;
		deleteCreatorProductModuleMutation.mutate(creatorModule.id);
	};

	if (!creatorModule) return null;

	const isDeleteable = source.creatorProductModules.length > 1 && deleteable;

	return (
		<Menu
			width={160}
			position="right"
			closeOnItemClick={false}
			opened
			closeOnClickOutside={false}
			withArrow={false}
			onClose={handleClose}
		>
			<Menu.Target>
				<Anchor
					style={{
						position: 'fixed',
						top: position[1],
						left: position[0],
						visibility: 'hidden',
					}}
					onContextMenu={(e) => e.preventDefault()}
				>
					TRI
				</Anchor>
			</Menu.Target>
			<Menu.Dropdown>
				<Menu.Item
					leftSection={<IconRefresh size={20} />}
					onClick={handleSelectModuleToSwap}
				>
					{getContent(`${baseSlug}swap`)}
				</Menu.Item>
				<Menu.Divider />
				<Menu.Item
					color="red"
					leftSection={<IconTrash size={20} />}
					disabled={!isDeleteable}
					onClick={handleRemoveCreatorModule}
				>
					{getContent(`${baseSlug}remove`)}
				</Menu.Item>
			</Menu.Dropdown>
		</Menu>
	);
};
